export default ({ isAuthenticated }) => {
  if (isAuthenticated) return "logged in";
  return "anonymous";
};
